/*
  <atyp-hero>: homepage hero collage entrance.
  Vanilla Web Component using the globally loaded GSAP. On connect it staggers the real
  product photos into place (opacity, rise, slight scale). No scroll hijacking, it runs
  once on load. Progressive enhancement: the images are visible by default in CSS, so with
  no JS, no GSAP, or reduced-motion they simply show in their final state. The hidden
  starting state is only set in the same tick as the animation, so there is no flash and a
  GSAP failure can never leave the images hidden.
*/
if (!customElements.get('atyp-hero')) {
  customElements.define(
    'atyp-hero',
    class AtypHero extends HTMLElement {
      connectedCallback() {
        var items = Array.prototype.slice.call(this.querySelectorAll('[data-hero-img]'));
        if (!items.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var host = this;

        // Pointer depth: collage figures (and the ghost word) drift a few px
        // toward the pointer, each by its own data-hero-depth factor. Desktop
        // fine pointers only, transform only, listeners scoped to the hero band.
        function armDepth() {
          var g = window.gsap;
          if (!g) return;
          if (!window.matchMedia('(pointer: fine) and (hover: hover)').matches) return;
          var band = host.closest('.atyp-hero') || host;
          var layers = Array.prototype.slice.call(band.querySelectorAll('[data-hero-depth]'));
          if (!layers.length) return;
          var movers = layers.map(function (el) {
            return {
              depth: parseFloat(el.getAttribute('data-hero-depth')) || 8,
              toX: g.quickTo(el, 'x', { duration: 0.6, ease: 'power2.out' }),
              toY: g.quickTo(el, 'y', { duration: 0.6, ease: 'power2.out' })
            };
          });
          band.addEventListener('pointermove', function (e) {
            var r = band.getBoundingClientRect();
            if (!r.width || !r.height) return;
            var px = (e.clientX - r.left) / r.width - 0.5;
            var py = (e.clientY - r.top) / r.height - 0.5;
            movers.forEach(function (m) {
              m.toX(px * 2 * m.depth);
              m.toY(py * 2 * m.depth);
            });
          }, { passive: true });
          band.addEventListener('pointerleave', function () {
            movers.forEach(function (m) { m.toX(0); m.toY(0); });
          }, { passive: true });
        }

        function animate() {
          var g = window.gsap;
          if (!g) return;
          g.set(items, { opacity: 0, y: 28, scale: 0.94 });
          g.to(items, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.9,
            stagger: 0.12,
            ease: 'power3.out',
            clearProps: 'transform',
            onComplete: armDepth
          });
        }

        if (window.gsap) {
          animate();
          return;
        }
        // GSAP is deferred too; wait briefly, then fail open to visible.
        var n = 0;
        var iv = setInterval(function () {
          if (window.gsap) {
            clearInterval(iv);
            animate();
          } else if (++n > 100) {
            clearInterval(iv);
          }
        }, 50);
      }
    }
  );
}
